import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.scss';

const GlideControls = ({ slideCount, withoutControls }) => {
  if (withoutControls) {
    return false;
  }
  return (
    <div className={styles.controls}>
      <div data-glide-el="controls">
        <span data-glide-dir="<" className={cx(styles.arrows, 'icon', 'icon-back-arrow')} />
      </div>
      <div data-glide-el="controls[nav]">
        {[...Array(slideCount)].map((_, index) => (
          <button
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            type="button"
            className={cx('glide__bullet', styles.dots)}
            data-glide-dir={`=${index}`}
          />
        ))}
      </div>
      <div data-glide-el="controls">
        <span data-glide-dir=">" className={cx(styles.arrows, 'icon', 'icon-select-arrow')} />
      </div>
    </div>
  );
};

GlideControls.propTypes = {
  slideCount: PropTypes.number.isRequired,
  withoutControls: PropTypes.bool.isRequired,
};

export default GlideControls;
